/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_TitleInputs */

const en_invoice_request_title = /** @type {(inputs: Invoice_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request an invoice`)
};

const pl_invoice_request_title = /** @type {(inputs: Invoice_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poproś o fakturę`)
};

/**
* | output |
* | --- |
* | "Request an invoice" |
*
* @param {Invoice_Request_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_title = /** @type {((inputs?: Invoice_Request_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_title(inputs)
	return en_invoice_request_title(inputs)
});